import setAgentLocalState from 'actions/agent_local_state/set_agent_local_state';
import { SidePanelType } from 'models/side_panel';

export default class ToggleSidebarCollapse {
  constructor(context) {
    this.context = context;
  }

  run({ windowWidth }) {
    const localState = this.context.stores.agentLocalState.get();
    localState.toggleShouldCollapseSidebar();
    setAgentLocalState(this.context, localState);

    const sidePanel = this.context.stores.sidePanel.get();
    this.context.analytics.track('Customer List Collapse Toggled', {
      collapsed: localState.shouldCollapseSidebar,
      isAnswerPanelOpen: sidePanel.isShowing(SidePanelType.ANSWER),
      isTaskPanelOpen: sidePanel.isShowing(SidePanelType.TASK),
      windowWidth,
    });
  }
}
